/** 이 브라우저가 만든 jobId 를 적어 두는 자리. **목록의 정본이 아니다.**
 *
 * 예전 머리말은 서버에 목록 라우트가 없다고 적었는데 그 말은 거짓이 됐다. `GET /api/jobs` 는
 * 서 있고(`listJobs`) `W-20`·`W-55` 는 서버 목록만 그린다. 그래서 이 파일을
 * 읽는 화면은 없다. 읽던 `listLocalJobs` 와 지우던 `forgetJob` 은 아무도 import 하지 않아
 * 걷었다.
 *
 * ⚠️ **남은 `rememberJob` 도 지금은 쓰기만 하고 읽는 곳이 없다.** 부르는 곳이
 * `features/upload/UploadPanel.tsx` 둘이라 그 파일과 함께 걷어야 한다. */

const KEY = "makit.jobs.v1";

export interface LocalJobRef {
  jobId: string;
  /** 이 저장소가 아는 것은 언제나 "웹"이다. */
  origin: "web";
  createdAt: string;
  imageCount: number;
}

function read(): LocalJobRef[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as LocalJobRef[]) : [];
  } catch {
    return [];
  }
}

function write(refs: LocalJobRef[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(refs));
  } catch {
    /* 프라이빗 모드 등에서 막힐 수 있다 — 목록만 비고 업로드는 계속 된다. */
  }
}

export function rememberJob(jobId: string, imageCount: number): void {
  const refs = read().filter((r) => r.jobId !== jobId);
  refs.push({ jobId, origin: "web", createdAt: new Date().toISOString(), imageCount });
  write(refs);
}

/** **계정이 끝날 때 부른다**(`app/SessionGate.tsx` 의 로그아웃 · 세션이 풀린 때 · 계정이 바뀐 때).
 *
 * 이 저장소의 키는 **계정을 가르지 않는다.** 그래서 앞 셀러가 만든 작업 id 와 장수가 같은
 * 브라우저의 다음 셀러 아래에 그대로 남는다. 지금은 읽는 화면이 없지만, 읽는 화면이 다시
 * 생기는 날 그 줄이 남의 정보가 된다. 서버가 `GET /api/jobs` 로 목록을 주므로 지워도 잃는
 * 것이 없다(앱의 `forgetAllJobRecords` 와 같은 판단).
 *
 * 실패해도 던지지 않는다. 로그아웃은 서버 무효화와 캐시 비우기로 성립한다. */
export function forgetAllJobs(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* 저장소가 막힌 브라우저다. 막혔으면 쓰인 것도 없다. */
  }
}
